// extracted by mini-css-extract-plugin
module.exports = {"mouthBackgroundRoot":"mouthbackground_mouthBackgroundRoot__VOsEW","mouth":"mouthbackground_mouth__3e8JN"};